import { formatAccountDisplayName } from "./helpers";

export const getInstitutionId = (institution) =>
  typeof institution === "string" ? institution : institution?.uuid;

export const getAccountId = (account) =>
  typeof account === "string" ? account : account?.uuid;

export const getInstitutionLabel = (institution, metadata = []) => {
  if (typeof institution === "object" && institution?.institution_name) {
    return institution.institution_name;
  }

  const institutionId = getInstitutionId(institution);
  const match = metadata.find(
    (item) => String(item.uuid) === String(institutionId),
  );

  return match?.institution_name || institutionId || "";
};

export const getAccountLabel = (account, metadata = []) => {
  const accountId = getAccountId(account);
  const institution = metadata.find((item) =>
    item.accounts.some(
      (metadataAccount) => String(metadataAccount.uuid) === String(accountId),
    ),
  );
  const metadataAccount = institution?.accounts.find(
    (item) => String(item.uuid) === String(accountId),
  );
  const accountName =
    (typeof account === "object" && account?.name) ||
    metadataAccount?.name ||
    accountId ||
    "";
  const formattedAccountName = formatAccountDisplayName(
    accountName,
    metadataAccount || account,
  );

  return institution
    ? `${formattedAccountName} (${institution.institution_name})`
    : formattedAccountName;
};

export const budgetMatchesFilters = (row, filters) => {
  const matchInstitution = filters.institutions
    ? row.institutions.some(
        (institution) =>
          String(getInstitutionId(institution)) ===
          String(filters.institutions),
      )
    : true;

  const matchAccount = filters.accounts
    ? row.accounts.some(
        (account) =>
          String(getAccountId(account)) === String(filters.accounts),
      )
    : true;

  const matchCategory = filters.categories
    ? row.categories.some(
        (category) =>
          String(category).toUpperCase() ===
          String(filters.categories).toUpperCase(),
      )
    : true;

  const matchFrequency = filters.frequency
    ? row.frequency === filters.frequency
    : true;

  return matchInstitution && matchAccount && matchCategory && matchFrequency;
};
